module.exports = __webpack_public_path__ + "static/media/6.d87e2b87.svg";